import React from "react";
import {useDispatch} from "react-redux";
import Card from "../Card/index.jsx";
import {roomPlayCard, roomSelectCombinationCard} from "../../../../redux/actions/rooms/actions.js";
import classNames from "classnames";
import useDealtHandCards from "./cardAnimationHook.jsx";

const Hand = function (props) {
    const {
        roomId,
        cards,
        isViewRoom,
        isBottom,
        activeHand,
        playedCard,
        playerId,
        boardWinnerId,
        hiddenBitaCards,
        selectedCombinationCards,
        cardsSelectable,
        publishedCombinationCards,
        resetHand,
        playShuffle,
        playCardBita,
        playCardSound
    } = props;
    const dispatch = useDispatch();

    const {
        handCards,
        activeCardCount,
        bitaCards,
    } = useDealtHandCards(
        cards,
        100,
        selectedCombinationCards,
        resetHand,
        playedCard,
        boardWinnerId,
        300
    );

    const handleCardClick = (index, card) => {
        if (!isBottom || isViewRoom || !activeHand || !card?.playable) return null;
        if (cardsSelectable) {
            dispatch(roomSelectCombinationCard({roomId, card}))
        } else {
            dispatch(roomPlayCard({roomId, cardIndex: index}));
        }
    }

    return <div className={`
                 card-count-${activeCardCount}
                ${isBottom ? 'bottom-cards-wrap' : 'top-cards-wrap'}
            `}>

        {handCards.map((card, index) => {
            let cardName = card?.name;
            if (!cardName && publishedCombinationCards?.[index]) {
                cardName = publishedCombinationCards?.[index]
            }
            return <Card
                key={index}
                inHand={card?.inHand}
                played={card?.played}
                passed={card?.passed}
                playShuffle={playShuffle}
                playCardBita={playCardBita}
                playCardSound={playCardSound}
                handleClick={() => handleCardClick(index, card)}
                className={classNames({
                    [`card-name_${cardName}`]: cardName,
                    [`card_${card?.index + 1}`]: card?.inHand,
                    'card-passed': card?.passed,
                    'card-visible': card?.suit || isViewRoom && publishedCombinationCards?.[index],
                    'card-not-visible': hiddenBitaCards?.includes(index) || resetHand,
                    'cards-not-active': !isBottom || (isBottom && !activeHand),
                    'playable':!isBottom || (isBottom && activeHand && card?.playable),
                    'not-playable': isBottom && (!activeHand || !card?.playable),
                    'card-bottom-played': isBottom && playedCard === index,
                    'card-top-played': !isBottom && playedCard === index,
                    'card-selected': card?.inCombination,
                    'card-selectable': isBottom && cardsSelectable,
                    'bita-top': bitaCards?.includes(index) && (isBottom ? card?.bita !== playerId : card?.bita === playerId),
                    'bita-bottom': bitaCards?.includes(index) && card?.bita && (isBottom ? card?.bita === playerId : card?.bita !== playerId),
                    'card-combination-bottom': isBottom && publishedCombinationCards?.[index],
                    'card-combination-top': !isBottom && publishedCombinationCards?.[index],
                    [`played-card-order-${card?.priority}`]: card?.priority
                })}
            />
        })}
    </div>
}

export default Hand;

